<script>import FieldContainer from "./helper/FieldContainer.svelte";
import PasswordInput from "./helper/PasswordInput.svelte";
import CheckBox from "./helper/CheckBox.svelte";
import { createFieldContext } from "./helper/field.js";
import { getContext } from "svelte";
export let name = void 0;
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = void 0;
export let value = void 0;
export let error = void 0;
export let disabled = false;
export let showPasswordMode = void 0;
export let control = void 0;
export const locale = void 0;
export const context = void 0;
if (showPasswordMode === void 0 && control !== void 0) {
  showPasswordMode = control.input.properties?.visible;
}
showPasswordMode = showPasswordMode ?? "last";
const contextKey = createFieldContext(name, value, error, disabled, value === void 0);
const ctx = getContext(contextKey);
const ctxValue = ctx.value;
const toggleContextKey = createFieldContext("", false, void 0, disabled, false);
const toggleCtx = getContext(toggleContextKey);
$: {
  ctx.value.set(value);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value === void 0);
}
let showPassword = toggleCtx.value;
let showLast = showPasswordMode === "last";
$:
  value = $ctxValue;
$:
  props = {
    label: label.split(":")[0],
    callToInput: callToInput ? callToInput.split(":")[0] : void 0,
    assistText: assistText ? assistText.split(":")[0] : void 0,
    story,
    contextKey
  };
</script>

<FieldContainer {...props}>
	<svelte:fragment slot="input">
		<PasswordInput
			showPassword={$showPassword}
			{showLast}
			{contextKey}
			on:changed
			on:state
		/>
	</svelte:fragment>
	<svelte:fragment slot="rest">
		{#if showPasswordMode !== 'never'}<CheckBox
				story="iconToggle.eyes"
				contextKey={toggleContextKey}
			/>{/if}
	</svelte:fragment>
</FieldContainer>
